/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import { getAPIConfig, parseBoolean } from '@tcp/core/src/utils';
import constants from '../constants';

const buildSsrLightWeightQuery = ({ brand, country, channel, lang }) => `
  navigation: mainNavigation(brand: "${brand}", country: "${country}", channel: "${channel}", lang: "${lang}") {
    errorMessage
    categoryContent {
      catgroupId
      name
      id
      seoToken
      groupIdentifier
      displayToCustomer
      linkedCategory
      carouselType
      stageHoldCategory
      heroCategorySlotting
      mainCategory {
        hidePlpGridAndFilters
        espotPlp {
          contentId
        }
      }
    }
    subCategories {
      categoryContent {
        catgroupId
        name
        id
        seoToken
        groupIdentifier
        displayToCustomer
        linkedCategory
        carouselType
        stageHoldCategory
        heroCategorySlotting
        mainCategory {
          hidePlpGridAndFilters
          espotPlp {
            contentId
          }
        }
      }
      subCategories {
        categoryContent {
          catgroupId
          name
          id
          seoToken
          groupIdentifier
          displayToCustomer
          linkedCategory
          carouselType
          stageHoldCategory
          heroCategorySlotting
          mainCategory {
            hidePlpGridAndFilters
            espotPlp {
              contentId
            }
          }
        }
      }
    }
  }
`;

const buildSsrBotQuery = ({ brand, country, channel, lang }) => `
  navigation: mainNavigation(brand: "${brand}", country: "${country}", channel: "${channel}", lang: "${lang}") {
    errorMessage
    categoryContent {
      catgroupId
      name
      id
      seoToken
      groupIdentifier
      displayToCustomer
      linkedCategory
      carouselType
      mainCategory {
        set {
          key
          val
        }
        categoryFilterImage {
          url
          alt
          title
          crop_d
          crop_m
          crop_t
          position
          url_t
        }
        hidePlpGridAndFilters
        espotPlp {
          contentId
        }
      }
    }
    subCategories {
      categoryContent {
        catgroupId
        name
        id
        seoToken
        groupIdentifier
        displayToCustomer
        linkedCategory
        carouselType
        mainCategory {
          set {
            key
            val
          }
          categoryFilterImage {
            url
            alt
            title
            crop_d
            crop_m
            crop_t
            position
            url_t
          }
          hidePlpGridAndFilters
          espotPlp {
            contentId
          }
        }
      }
      subCategories {
        categoryContent {
          catgroupId
          name
          id
          seoToken
          groupIdentifier
          displayToCustomer
          linkedCategory
          carouselType
          mainCategory {
            set {
              key
              val
            }
            categoryFilterImage {
              url
              alt
              title
              crop_d
              crop_m
              crop_t
              position
              url_t
            }
            hidePlpGridAndFilters
            espotPlp {
              contentId
            }
          }
        }
      }
    }
  }
`;

const buildSsrQuery = ({ brand, country, channel, lang }) => `
  navigation: mainNavigation(brand: "${brand}", country: "${country}", channel: "${channel}", lang: "${lang}") {
    errorMessage
    categoryContent {
      catgroupId
      name
      id
      seoToken
      groupIdentifier
      displayToCustomer
      linkedCategory
      carouselType
      outfitsPlp
      productTile
      viewType
      stageHoldCategory
      heroCategorySlotting
      mainCategory {
        set {
          key
          val
        }
        hidePlpGridAndFilters
        espotPlp {
          contentId
        }
      }
    }
    subCategories {
      categoryContent {
        catgroupId
        name
        id
        seoToken
        groupIdentifierSequence
        groupIdentifier
        groupIdentifierName
        displayToCustomer
        linkedCategory
        carouselType
        outfitsPlp
        productTile
        viewType
        stageHoldCategory
        heroCategorySlotting
        mainCategory {
          set {
            key
            val
          }
          hidePlpGridAndFilters
          espotPlp {
            contentId
          }
        }
      }
      subCategories {
        categoryContent {
          catgroupId
          name
          id
          seoToken
          groupIdentifierSequence
          groupIdentifier
          groupIdentifierName
          displayToCustomer
          linkedCategory
          carouselType
          outfitsPlp
          productTile
          viewType
          stageHoldCategory
          heroCategorySlotting
          mainCategory {
            set {
              key
              val
            }
            hidePlpGridAndFilters
            espotPlp {
              contentId
            }
          }
        }
      }
    }
  }
`;

const buildCsrLightWeightQuery = ({ brand, country, channel, lang, depth }) => `
  navigation: mainNavigation(brand: "${brand}", country: "${country}", channel: "${channel}", lang: "${lang}") {
    errorMessage
    ${
      !depth || depth > 1
        ? `
    categoryContent {
      catgroupId
      name
      id
      seoToken
      groupIdentifier
      displayToCustomer
      linkedCategory
      isShortImage
      sizeChartSelection
      excludeAttribute
      carouselType
      stageHoldCategory
      heroCategorySlotting
      mainCategory {
        set {
          key
          val
        }
        sizesRange {
          text
        }
        sizesRangeMobile {
          text
        }
        promoBadge {
          text
          style
        }
        promoBadgeMobile {
          text
          style
        }
        categoryFilterImage {
          url
          alt
          title
          crop_d
          crop_m
          crop_t
          position
          url_t
        }
        categoryLayout {
          name
          headerDesktop
          columns {
            imageBanner {
              image {
                url
                alt
                title
                crop_d
                crop_m
                crop_t
              }
              link {
                url
                text
                title
                target
              }
            }
            shopBySize {
              text {
                text
              }
              linkList {
                url
                title
                text
                target
              }
            }
            textBanner {
              link {
                url
                text
                title
                target
                external
                action
              }
              category
              textItems {
                text
                style
              }
              set {
                key
                val
              }
            }
          }
        }
        categoryLayoutMobile {
          name
          headerMobile
          columns {
            imageBanner {
              image {
                url
                alt
                title
                crop_d
                crop_m
                crop_t
              }
              link {
                url
                text
                title
                target
              }
            }
            shopBySize {
              text {
                text
              }
              linkList {
                url
                title
                text
                target
              }
            }
            textBanner {
              link {
                url
                text
                title
                target
                external
                action
              }
              category
              textItems {
                text
                style
              }
              set {
                key
                val
              }
            }
          }
        }
        hidePlpGridAndFilters
        espotPlp {
          contentId
        }
      }
    }`
        : `
    categoryContent {
      name
      id
    }`
    }
    ${
      depth || depth > 1
        ? `
    subCategories {
      categoryContent {
        seoToken
        groupIdentifier
        name
        id
        catgroupId
        displayToCustomer
        linkedCategory
        isShortImage
        sizeChartSelection
        excludeAttribute
        carouselType
        stageHoldCategory
        heroCategorySlotting
        mainCategory {
          promoBadge {
            text
          }
          promoBadgeMobile {
            text
          }
          set {
            key
            val
          }
          categoryFilterImage {
            url
            alt
            title
            crop_d
            crop_m
            crop_t
            position
          }
          hidePlpGridAndFilters
          espotPlp {
            contentId
          }
        }
      }
      subCategories {
        categoryContent {
          seoToken
          groupIdentifier
          name
          id
          catgroupId
          displayToCustomer
          linkedCategory
          isShortImage
          excludeAttribute
          carouselType
          stageHoldCategory
          heroCategorySlotting
                    mainCategory {
            promoBadge {
              text
            }
            promoBadgeMobile {
              text
            }
            set {
              key
              val
            }
            espotPlp {
              contentId
            }
          }
          sizeChartSelection
          mainCategory {
            categoryFilterImage {
              url
              alt
              title
              crop_d
              crop_m
              crop_t
              position
            }
            hidePlpGridAndFilters
            espotPlp {
              contentId
            }
          }
        }
      }
    }
    `
        : ``
    }
  }
`;

const buildQuery = ({ brand, country, channel, lang, depth }) => `
  navigation: mainNavigation(brand: "${brand}", country: "${country}", channel: "${channel}", lang: "${lang}") {
    errorMessage
    ${
      !depth || depth > 1
        ? `
    categoryContent {
      catgroupId
      name
      id
      seoToken
      groupIdentifier
      displayToCustomer
      linkedCategory
      isShortImage
      sizeChartSelection
      excludeAttribute
      carouselType
      outfitsPlp
      productTile
      viewType
      stageHoldCategory
      heroCategorySlotting
      mainCategory {
        set {
          key
          val
        }
        sizesRange {
          text
        }
        sizesRangeMobile {
          text
        }
        promoBadge {
          text
          style
        }
        promoBadgeMobile {
          text
          style
        }
        categoryFilterImage {
          url
          alt
          title
          crop_d
          crop_m
          crop_t
          position
          url_t
        }
        categoryLayout {
          name
          headerDesktop
          columns {
            imageBanner {
              image {
                url
                alt
                title
                crop_d
                crop_m
                crop_t
              }
              link {
                url
                text
                title
                target
              }
            }
            shopBySize {
              text {
                text
              }
              linkList {
                url
                title
                text
                target
              }
            }
            textBanner {
              link {
                url
                text
                title
                target
                external
                action
              }
              category
              textItems {
                text
                style
              }
              set {
                key
                val
              }
            }
          }
        }
        categoryLayoutMobile {
          name
          headerMobile
          columns {
            imageBanner {
              image {
                url
                alt
                title
                crop_d
                crop_m
                crop_t
              }
              link {
                url
                text
                title
                target
              }
            }
            shopBySize {
              text {
                text
              }
              linkList {
                url
                title
                text
                target
              }
            }
            textBanner {
              link {
                url
                text
                title
                target
                external
                action
              }
              category
              textItems {
                text
                style
              }
              set {
                key
                val
              }
            }
          }
        }
        hidePlpGridAndFilters
        espotPlp {
          contentId
        }
      }
    }`
        : `
    categoryContent {
      name
      id
    }`
    }
    ${
      depth || depth > 1
        ? `
    subCategories {
      categoryContent {
        seoToken
        groupIdentifierSequence
        groupIdentifier
        groupIdentifierName
        name
        id
        catgroupId
        displayToCustomer
        linkedCategory
        isShortImage
        sizeChartSelection
        excludeAttribute
        carouselType
        outfitsPlp
        productTile
        viewType
        stageHoldCategory
        heroCategorySlotting
        mainCategory {
          promoBadge {
            text
          }
          promoBadgeMobile {
            text
          }
          set {
            key
            val
          }
          categoryFilterImage {
            url
            alt
            title
            crop_d
            crop_m
            crop_t
            position
          }
          hidePlpGridAndFilters
          espotPlp {
            contentId
          }
        }
      }
      subCategories {
        categoryContent {
          seoToken
          groupIdentifierSequence
          groupIdentifier
          groupIdentifierName
          name
          id
          catgroupId
          displayToCustomer
          linkedCategory
          isShortImage
          excludeAttribute
          carouselType
          outfitsPlp
          productTile
          viewType
          stageHoldCategory
          heroCategorySlotting
          mainCategory {
            promoBadge {
              text
            }
            promoBadgeMobile {
              text
            }
            set {
              key
              val
            }
            espotPlp {
              contentId
            }
          }
          sizeChartSelection
          mainCategory {
            categoryFilterImage {
              url
              alt
              title
              crop_d
              crop_m
              crop_t
              position
            }
            hidePlpGridAndFilters
            espotPlp {
              contentId
            }
          }
        }
      }
    }
    `
        : ``
    }
  }
`;

export default {
  getQuery: (data) => {
    const { type, deviceType } = data;
    const navSSR = 'navigation-ssr';
    const isBotDevice = deviceType === 'bot';
    const { isLightWeightNavigationAPIEnabled } = getAPIConfig() || {};
    const lightWeightNavigationAPI =
      isLightWeightNavigationAPIEnabled === 'false'
        ? false
        : parseBoolean(isLightWeightNavigationAPIEnabled);

    if (type === navSSR && isBotDevice) {
      return {
        query: buildSsrBotQuery(data),
        cacheTag: constants.TYPE_NAVIGATION,
      };
    }
    if (type === navSSR && lightWeightNavigationAPI) {
      return {
        query: buildSsrLightWeightQuery(data),
        cacheTag: constants.TYPE_NAVIGATION,
      };
    }
    if (type === navSSR) {
      return {
        query: buildSsrQuery(data),
        cacheTag: constants.TYPE_NAVIGATION,
      };
    }
    if (lightWeightNavigationAPI) {
      return {
        query: buildCsrLightWeightQuery(data),
        cacheTag: constants.TYPE_NAVIGATION,
      };
    }
    return {
      query: buildQuery(data),
      cacheTag: constants.TYPE_NAVIGATION,
    };
  },
};
